import { Box } from '@mui/material'
import './styles.css'

const LoaderProgress = ({ onClose, sx }) => {
  const handleCloseprev = (e, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown"))
      return;
    onClose();
  }
  const defaultSx = { minHeight: 600 };
  const mergedSx = { ...defaultSx, ...sx };
  return (
    <Box
      onClose={handleCloseprev}
      display="flex"
      justifyContent="center"
      direction="column"
      alignItems="center"
      sx={mergedSx}
    >
      <div className="spinner"></div>
    </Box>
  )
}

export default LoaderProgress;